import { Toast } from 'vant'
import Http from '../lib/http'
import Api from '../lib/api'
import Vue from 'vue'
import Router from '../router'
import native from '../lib/native'
/*
  获取目标类型字典返回
*/
export const getTypeDict = (code, path) => {
  let dict = {}
  for (let i = 0; i < Vue.prototype.$typeList.length; i++) {
    if (code && code === Vue.prototype.$typeList[i].code) {
      dict = Vue.prototype.$typeList[i]
      break
    }
    if (path && path === Vue.prototype.$typeList[i].formPath) {
      dict = Vue.prototype.$typeList[i]
      break
    }
  }
  return dict
}

/*
  根据类型组装附件字典
*/
export const getAttachDict = (attachUrls, typeId) => {
  let attachDict = {}
  attachDict['typeid'] = typeId
  let attachUrl = ''
  for (let i = 0; i < attachUrls.length; i++) {
    if (i > 0) {
      attachUrl = attachUrl + ',' + attachUrls[i].url
    } else {
      attachUrl = attachUrls[i].url
    }
  }
  attachDict['url'] = attachUrl
  return attachDict
}

/*
  组装附件字典  2.masterUrls:身份证 3.hourseUrls：房屋产权证 4:gzbxUrls：故障报修 5.txjyUrls：投诉建议 6.wscbUrls：网上抄表
*/
export const getAttach = (masterUrls, hourseUrls, gzbxUrls, tsjyUrls, wscbUrls) => {
  let attach = []
  if (masterUrls.length > 0) {
    let masterDict = getAttachDict(masterUrls, 2)
    attach.push(masterDict)
  }
  if (hourseUrls.length > 0) {
    let hourseDict = getAttachDict(hourseUrls, 3)
    attach.push(hourseDict)
  }
  if (gzbxUrls.length > 0) {
    let gzbxDict = getAttachDict(gzbxUrls, 4)
    attach.push(gzbxDict)
  }
  if (tsjyUrls.length > 0) {
    let tsjyDict = getAttachDict(tsjyUrls, 5)
    attach.push(tsjyDict)
  }
  if (wscbUrls.length > 0) {
    let wscbDict = getAttachDict(wscbUrls, 6)
    attach.push(wscbDict)
  }
  return attach
}

/*
  解析附件格式，用于表单预览
*/
export const analysisAttach = (res) => {
  let result = {}

  let uploaderMst = []
  let uploaderHs = []
  let uploaderGZBX = []
  let uploaderTSJY = []
  let uploaderWSCB = []

  let masterUrls = []
  let hourseUrls = []
  let gzbxUrls = []
  let tsjyUrls = []
  let wscbUrls = []

  if (res.attach) {
    for (let i = 0; i < res.attach.length; i++) {
      if (res.attach[i].url) {
        let urlList = res.attach[i].url.split(',')
        for (let j = 0; j < urlList.length; j++) {
          if (res.attach[i].typeid === 2) {
            uploaderMst.push({
              url: Vue.prototype.$imgBaseUrl + urlList[j]
            })
            masterUrls.push({
              url: urlList[j]
            })
          }
          if (res.attach[i].typeid === 3) {
            uploaderHs.push({
              url: Vue.prototype.$imgBaseUrl + urlList[j]
            })
            hourseUrls.push({
              url: urlList[j]
            })
          }
          if (res.attach[i].typeid === 4) {
            uploaderGZBX.push({
              url: Vue.prototype.$imgBaseUrl + urlList[j]
            })
            gzbxUrls.push({
              url: urlList[j]
            })
          }
          if (res.attach[i].typeid === 5) {
            uploaderTSJY.push({
              url: Vue.prototype.$imgBaseUrl + urlList[j]
            })
            tsjyUrls.push({
              url: urlList[j]
            })
          }
          if (res.attach[i].typeid === 6) {
            uploaderWSCB.push({
              url: Vue.prototype.$imgBaseUrl + urlList[j]
            })
            wscbUrls.push({
              url: urlList[j]
            })
          }
        }
      }
    }
    result['uploaderMst'] = uploaderMst
    result['uploaderHs'] = uploaderHs
    result['uploaderGZBX'] = uploaderGZBX
    result['uploaderTSJY'] = uploaderTSJY
    result['uploaderWSCB'] = uploaderWSCB

    result['masterUrls'] = masterUrls
    result['hourseUrls'] = hourseUrls
    result['gzbxUrls'] = gzbxUrls
    result['tsjyUrls'] = tsjyUrls
    result['wscbUrls'] = wscbUrls
  }
  return result
}

/*
  获取业务办理详情
*/
export const getBussInfo = (busscode, bussno) => {
  return Http.post(Api.getBussInfo, {
    busscode: busscode,
    bussno: bussno
  }).then(res => {
    if (res.code === '000') {
      if (res.data.remark === null) {
        res.data.remark = ''
      }
      if (res.data.reason === null) {
        res.data.reason = ''
      }
      return res.data
    } else {
      Toast(res.msg)
    }
  })
}

/*
  返回上一页
*/
export const onClickLeft = () => {
  Router.go(-1)
}

/*
  验证手机号
*/
export const validator = (val) => {
  if (val) {
    return Vue.prototype.$pattern.test(val);
  }
}

/*
  验证身份证
*/
export const validatorId = (identityId) => {
  // if (val) {
  //   return Vue.prototype.$patternId.test(val);
  // }
  if (identityId === '') return true;
  var patrn = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;//长度或格式校验
  //地区校验
  var aCity = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外"
  };
  // 出生日期验证
  var sBirthday = (
    identityId.substr(6, 4) +
    "-" +
    Number(identityId.substr(10, 2)) +
    "-" +
    Number(identityId.substr(12, 2))
  ).replace(/-/g, "/"),
    d = new Date(sBirthday)
  // 身份证号码校验 最后4位  包括最后一位的数字/字母X
  var sum = 0,
    weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
    codes = "10X98765432";
  for (var i = 0; i < identityId.length - 1; i++) {
    sum += identityId[i] * weights[i];
  }
  var last = codes[sum % 11]; //计算出来的最后一位身份证号码

  var errorMsg = '';
  if (identityId === '') {
    errorMsg = "身份证号不能为空"
  } else if (!patrn.exec(identityId)) {
    errorMsg = "你输入的身份证长度或格式错误"
  } else if (!aCity[parseInt(identityId.substr(0, 2))]) {
    errorMsg = "你的身份证地区非法"
  } else if (sBirthday != d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()) { errorMsg = "身份证上的出生日期非法" } else if (identityId[identityId.length - 1] != last) {
    errorMsg = "你输入的身份证号非法"
  }
  return errorMsg == "" ? true : false;
}

/*
  验证邮箱
*/
export const validatorEmail = (val) => {
  if (val) {
    return Vue.prototype.$patternEmail.test(val);
  }
}

/*
  获取文件后缀名
*/
export const extname = (filename) => {
  if (!filename || typeof filename != 'string') {
    return false
  }
  let a = filename.split('').reverse().join('');
  let b = a.substring(0, a.search(/\./)).split('').reverse().join('');
  return b
}

/*
  获取绑定用户列表
*/
export const getUserList = () => {
  return Http.post(Api.userList, {
  }).then(res => {
    if (res.code === '000') {
      return res.data
    } else {
      Toast(res.msg)
    }
  })
}

/*
  获取用户信息
*/
export const getUserInfo = (userno, username) => {
  return Http.post(Api.getUserInfo, {
    userno: userno,
    username: username ? username : null
  }).then(res => {
    if (res.code === '000') {
      return res.data
    } else {
      Toast(res.msg)
    }
  })
}

export const loading = (message) => {
  if (!message) {
    message = '加载中...'
  }
  Toast.loading({
    // mask: true, //蒙层
    duration: 0, // 持续展示 toast
    forbidClick: true, // 禁用背景点击
    loadingType: 'spinner',
    message: message
  })
}

export const clear = () => {
  Toast.clear()
}

/**
 * 获取url参数
 * @param {*} name
 * @param {*} type
 */
export const GetQueryString = (n) => {
  var fn = (name, type) => {
    let target
    if (type === 'hash') {
      target = window.location.hash.split('?')[1]
    } else {
      target = window.location.search.substr(1)
    }
    if (!target) {
      return null
    }
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    let r = target.match(reg)
    if (r != null) {
      return r[2]
    }
    return null
  }
  return fn(n) || fn(n, 'hash')
}

/**
 * 判断是否是ios
 */
export const isIos = () => {
  const u = navigator.userAgent
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

export const isAndroid = () => {
  const u = navigator.userAgent
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
}

export const isMobile = () => {
  return isIos() || isAndroid()
}

/**
 * 设置苹果/安卓标题
 * @param {*} title
 */
export const setDocumentTitle = (title) => {
  document.title = title
  if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
    var i = document.createElement('iframe')
    i.src = ''
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
  return null
}

export function makeCall(no) {
  let $frm = document.createElement('iframe')
  $frm.style.display = 'none'
  document.body.appendChild($frm)

  let $tel = document.createElement('a')
  $tel.setAttribute('href', `tel:${no}`)
  $frm.contentDocument.body.appendChild($tel)
  $tel.click()
  document.body.removeChild($frm)
}

// export const clickElement = ElementClick
// 原生跳转到用户缴费
export function userPay(item) {
  console.log(item)
  native.open_miniprogram({
    'params': {
      'userName': "gh_aceb9bd462ab"
    },
    cb: function (res) { console.log('singleDownload cb ', res); }
  });
}
// 获取当前地址参数
export function getUrlParam(name) {
  // 取得url中?后面的字符
  var query = window.location.search.substring(1)
  // 把参数按&拆分成数组
  var param_arr = query.split("&");
  for (var i = 0; i < param_arr.length; i++) {
    var pair = param_arr[i].split("=");
    if (pair[0] == name) {
      return pair[1];
    }
  }
  return (false);
}

export function dateFormat(d, pattern) {
  if (!d) return ''
  if (/.*[\u4e00-\u9fa5]+.*$/.test(d)) return d
  if (typeof d !== 'object') d = new Date(d)
  pattern = pattern || 'YYYY-MM-dd'
  var y = d.getFullYear().toString(),
    o = {
      M: d.getMonth() + 1,
      d: d.getDate(),
      h: d.getHours(),
      m: d.getMinutes(),
      s: d.getSeconds()
    }
  pattern = pattern.replace(/(y+)/ig, function (a, b) {
    return y.substr(4 - Math.min(4, b.length))
  })
  for (var i in o) {
    pattern = pattern.replace(new RegExp('(' + i + '+)', 'g'), function (a, b) {
      return (o[i] < 10 && b.length > 1) ? '0' + o[i] : o[i]
    })
  }
  return pattern
}

export default {
  getTypeDict,
  getAttach,
  analysisAttach,
  getBussInfo,
  onClickLeft,
  extname,
  validator,
  validatorId,
  validatorEmail,
  getUserList,
  getUserInfo,
  loading,
  clear,
  GetQueryString,
  isIos,
  isAndroid,
  setDocumentTitle,
  makeCall,
  isMobile,
  userPay,
  getUrlParam,
  dateFormat,
}
